module.exports = __webpack_public_path__ + "static/media/Emily01_thumb_hover.84d47a12.png";